import { PlusOutlined } from "@ant-design/icons";
import { Popover } from "antd";
import { AppButton } from "components/antd-ui";
import { memo, useCallback, useState } from "react";
import { ScenarioNodeType } from "types/scenario";
import { NODE_ADD_OPTIONS } from "../constants";
import "./FlowAddMenu.scss";

type FlowAddMenuItemProps = {
  type: ScenarioNodeType;
  label: string;
  desc: string;
  onPick: (type: ScenarioNodeType) => void;
};

const FlowAddMenuItem = memo(({ type, label, desc, onPick }: FlowAddMenuItemProps) => {
  const handleClick = useCallback(() => {
    onPick(type);
  }, [onPick, type]);

  return (
    <button type="button" className="flowAddMenuItem" onClick={handleClick}>
      {label}
      <small>{desc}</small>
    </button>
  );
});

FlowAddMenuItem.displayName = "FlowAddMenuItem";

type FlowAddMenuProps = {
  label: string;
  className?: string;
  size?: "small" | "middle";
  onPick: (type: ScenarioNodeType) => void;
};

export const FlowAddMenu = memo(({ label, className, size, onPick }: FlowAddMenuProps) => {
  const [open, setOpen] = useState(false);

  const handleOpenChange = useCallback((next: boolean) => {
    setOpen(next);
  }, []);

  const handlePick = useCallback(
    (type: ScenarioNodeType) => {
      setOpen(false);
      onPick(type);
    },
    [onPick],
  );

  return (
    <Popover
      trigger="click"
      placement="top"
      open={open}
      onOpenChange={handleOpenChange}
      overlayClassName="flowAddMenuOverlay"
      content={
        <div className="flowAddMenu">
          {NODE_ADD_OPTIONS.map((option) => (
            <FlowAddMenuItem
              key={option.type}
              type={option.type}
              label={option.label}
              desc={option.desc}
              onPick={handlePick}
            />
          ))}
        </div>
      }
    >
      <span className="flowAddMenuTrigger">
        <AppButton className={className} size={size} icon={<PlusOutlined />}>
          {label}
        </AppButton>
      </span>
    </Popover>
  );
});

FlowAddMenu.displayName = "FlowAddMenu";
